<template>
  <div>
      <v-dialog v-model="enable" max-width="290" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ title }}
            <v-spacer />
            <v-icon color="orange">warning</v-icon>
          </v-card-title>

          <v-card-text>{{ description }}</v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="primary darken-1" flat="flat" @click="toggle">
              {{ btnText }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    btnText: { type: String, default: "Entendido"}
  },
  data() {
    return {
      enable: this.value,
    }
  },
  watch: {
    value() {
      this.enable = this.value
    },
  },
  methods: {
    toggle() {
      this.$emit('toggle')
    },
  },
}
</script>

<style></style>
